<template>
  <dash-menu :links="links">
    <router-view></router-view>
  </dash-menu>
</template>

<script>
import DashMenu from "./DashMenu";
import { hasRole } from "../util";

export default {
  components: {
    DashMenu
  },
  computed: {
    links() {
      let id = this.$route.params.id;
      let links = [
        { name: "Fees", path: `/dash/${id}/fees/` },
        // { name: "Settled Cases", path: `/dash/${id}/fees/settled-cases` },
        { name: "Fee Projection", path: `/dash/${id}/fees/fee-projection` }
      ];
      let currentUser = this.$store.state.user.currentUser;
      if (!currentUser) return links;
      if (
        hasRole(currentUser, "attorney") ||
        hasRole(currentUser, "admin") ||
        hasRole(currentUser, "marketing")
      ) {
        links = links.concat([
          {
            name: "Attorney Stats",
            path: `/dash/${id}/fees/fee-attorney-stats`
          },
          { name: "Team Stats", path: `/dash/${id}/fees/team-stats` }
        ]);
      }
      return links;
    }
  }
};
</script>

<style scoped></style>
